import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Metrics',
      type: 'report-card',
      content: {
        '[]': [
          {
            '{}': {
              values: {
                '@': 'outcomeMetrics',
              },
            },
          },
        ],
      },
    },
  },
  subqueries: {
    outcomeMetrics: {
      filter: {
        and: [
          {
            '=': [
              {
                '@_': 'id',
              },
              {
                '@$': 'currentEntityId',
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!id',
              },
              {
                '@$': 'currentRecordId',
              },
            ],
          },
        ],
      },
      target: 'dim::!outcomes',
      quantity: 1,
      selection: {
        '@': 'metrics',
      },
      subqueries: {
        metrics: {
          target: 'ent:!outcome_metrics:!metric',
          ref: {
            attr: 'attr:ent#!outcome_metrics#!metric:!outcome',
          },
          selection: {
            '{}': {
              name: {
                '@.': '!name',
              },
              value: {
                '{}': {
                  aside: {
                    '++': [
                      {
                        if: [
                          [
                            {
                              not: {
                                '=': [
                                  {
                                    '@.': '!goal',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              '++': [
                                'goal ',
                                {
                                  '@.': '!goal',
                                },
                              ],
                            },
                          ],
                          '',
                        ],
                      },
                      {
                        if: [
                          [
                            {
                              not: {
                                '=': [
                                  {
                                    '@.': '!max',
                                  },
                                  null,
                                ],
                              },
                            },
                            {
                              '++': [
                                ' of ',
                                {
                                  '@.': '!max',
                                },
                              ],
                            },
                          ],
                          '',
                        ],
                      },
                    ],
                  },
                  tooltip: {
                    '@.': '!descr',
                  },
                  emphasis: {
                    '@.': '!value',
                  },
                  quality: {
                    if: [
                      [
                        {
                          '=': [{ '@.': '!goal' }, null],
                        },
                        '',
                      ],
                      [
                        {
                          '>=': [
                            {
                              '@.': '!value',
                            },
                            {
                              '@.': '!goal',
                            },
                          ],
                        },
                        'good',
                      ],
                      'bad',
                    ],
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
